// extracted by mini-css-extract-plugin
module.exports = {"normal":"Item_normal__2DFwW","linkOpen":"Item_linkOpen__1_sK1"};